/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface PrinterBase
 */
export interface PrinterBaseOptional {
  /**
   *
   * @type {string}
   * @memberof PrinterBase
   */
  printerUser?: string;
  /**
   *
   * @type {string}
   * @memberof PrinterBase
   */
  printerName?: string;
}

export interface PrinterBase extends PrinterBaseOptional {
  /**
   *
   * @type {string}
   * @memberof PrinterBase
   */
  printerUser?: string;
  /**
   *
   * @type {string}
   * @memberof PrinterBase
   */
  printerName?: string;
}

export interface PrinterBaseTrackedI {
  /**
   *
   * @type {string}
   * @memberof PrinterBase
   */
  printerUser?: string;
  printerUserIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PrinterBase
   */
  printerName?: string;
  printerNameIsSet: boolean;
}

transformDatesMap.set("PrinterBase", function (model: PrinterBase) {});

export type PrinterBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  printerUser: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  printerName: PropertyMeta<MetaTypeBase<string>>;
}>;

export var PrinterBaseMeta: PrinterBaseMetaI = {} as PrinterBaseMetaI;
PrinterBaseMeta = typeMeta("PrinterBase", {
  printerUser: propertyMeta(
    "printerUser",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  printerName: propertyMeta(
    "printerName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = PrinterBaseMeta;

registerMeta(() => {});

export class PrinterBaseTracked implements PrinterBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  printerUser__I?: string = undefined;
  printerUserIsSet: boolean = false;
  set printerUser(v: undefined | string) {
    if (v !== undefined) {
      this.printerUser__I = v;
      this.printerUserIsSet = true;
    } else {
      this.printerUser__I = v || undefined;
      this.printerUserIsSet = false;
    }
    this.changeTracker = true;
  }
  get printerUser() {
    return this.printerUser__I;
  }
  printerName__I?: string = undefined;
  printerNameIsSet: boolean = false;
  set printerName(v: undefined | string) {
    if (v !== undefined) {
      this.printerName__I = v;
      this.printerNameIsSet = true;
    } else {
      this.printerName__I = v || undefined;
      this.printerNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get printerName() {
    return this.printerName__I;
  }
  constructor(config?: PrinterBaseOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: PrinterBaseOptional,
    options?: AssignOptions,
  ): PrinterBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.printerUser &&
      this.printerUserApplyFilter(optionsRequired.filter)
    ) {
      this.printerUser = config.printerUser;
      if (optionsRequired.unassign) this.printerUserIsSet = false;
      else this.printerUserIsSet = true;
    }
    if (
      config.printerName &&
      this.printerNameApplyFilter(optionsRequired.filter)
    ) {
      this.printerName = config.printerName;
      if (optionsRequired.unassign) this.printerNameIsSet = false;
      else this.printerNameIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PrinterBaseTrackedI {
    const cloned = {} as PrinterBaseTrackedI;
    if (
      this.printerUserIsSetDeep() &&
      this.printerUserApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.printerUserIsSet = true;
      cloned.printerUser = this.printerUser;
    } else {
      //cloned.printerUserIsSet = false
    }
    if (
      this.printerNameIsSetDeep() &&
      this.printerNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.printerNameIsSet = true;
      cloned.printerName = this.printerName;
    } else {
      //cloned.printerNameIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PrinterBaseTrackedI {
    if (!this.printerUserApplyFilter(filter)) this.printerUserIsSet = false;

    if (!this.printerNameApplyFilter(filter)) this.printerNameIsSet = false;

    return this;
  }
  printerUserApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PrinterBaseMeta.printerUser,
      PrinterBaseMeta,
      this.printerUser,
      this,
    );
  }
  printerUserIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.printerUserIsSet && this.printerUserApplyFilter(filter))
      return true;

    return false;
  }
  printerNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PrinterBaseMeta.printerName,
      PrinterBaseMeta,
      this.printerName,
      this,
    );
  }
  printerNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.printerNameIsSet && this.printerNameApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.printerUserIsSetDeep(filter)) return true;
    if (this.printerNameIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
